<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="banner"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="标题" prop="title">
        <el-input
          v-model="banner.title"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入标题"
        />
      </el-form-item>

      <el-form-item label="链接" prop="link">
        <el-input
          v-model="banner.link"
          maxlength="250"
          show-word-limit
          clearable
          placeholder="请输入公众号链接或小程序链接"
        />
      </el-form-item>

      <v-image-upload
        v-model="banner.cover"
        :is-edit="true"
        label="轮播图"
        prefix="banner"
        ratio="2.35:1"
        prop-name="banner"
      />

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.bannerList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/banner';

export default {
  name: RouteConfig.bannerEdit.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    banner: {
      title: '',
      link: '',
      cover: '',
      update_time: 0,
    },
    rules: {
      title: [{ required: true, message: '请输入标题', trigger: 'change' }],
      cover: [{ required: true, message: '请上传轮播图', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.banner };
        const { isError } = await update(this.id, postData);
        this.isSaving = false;
        if (!isError) RouteConfig.bannerList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { banner } = this;
      const bannerInfo = {};
      Object.keys(data).forEach(key => {
        if (key in banner) bannerInfo[key] = data[key];
      });
      Object.assign(banner, bannerInfo);
    },
  },
};
</script>
